import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-paciente-dicom-banner",
  templateUrl: "./paciente-dicom-banner.component.html",
  styleUrls: ["./paciente-dicom-banner.component.scss"],
})
export class PacienteDicomBannerComponent {
  @Input() paciente: any;
  @Output() fusionar = new EventEmitter<void>();

  get esDeDicom(): boolean {
    return this.paciente?.origen === "dicom";
  }

  get faltantes(): string[] {
    if (!this.paciente) {
      return [];
    }

    const p = this.paciente;
    const faltan: string[] = [];

    if (
      !p.numeroDocumento ||
      String(p.numeroDocumento).indexOf("SIN-DOC-") === 0 ||
      String(p.numeroDocumento).indexOf("SIN-DNI-") === 0
    ) {
      faltan.push("DNI");
    }
    if (p.name === "Sin identificar" || p.surname === "Sin identificar") {
      faltan.push("Nombre y apellido");
    }
    if (
      !p.fechaNacimiento ||
      String(p.fechaNacimiento).indexOf("1900-01-01") === 0
    ) {
      faltan.push("Fecha de nacimiento");
    }
    if (!p.direccion || p.direccion === "Sin dato") {
      faltan.push("Dirección");
    }
    if (!p.email || String(p.email).endsWith(".invalid")) {
      faltan.push("Email");
    }
    if (!p.celNumero || p.celNumero === "0") {
      faltan.push("Teléfono");
    }
    if (!p.obraSocial || Number(p.obraSocial) === 0) {
      faltan.push("Obra social");
    }

    return faltan;
  }
}
